import React from 'react'
import { Input } from 'antd'

const Search = Input.Search

type Props = {
  onSearch: (
    value: string,
    event?:
      | React.ChangeEvent<HTMLInputElement>
      | React.MouseEvent<HTMLElement>
      | React.KeyboardEvent<HTMLInputElement>
  ) => void
  className?: string
  placeholder?: string
}

export const SearchOverviewTable: React.FC<Props> = ({ onSearch, placeholder, ...props }) => {
  return (
    <div {...props}>
      <Search
        allowClear={true}
        placeholder={placeholder || 'Enter Title'}
        onSearch={onSearch}
        style={{ width: 200 }}
      />
    </div>
  )
}
